module.exports = ".com-search-complaint {\n  align-items: center;\n  display: flex;\n  min-height: 100vh;\n}"